/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext } from "react";
import { ContentZoneContext } from "cms/components/context";
import { TableOfContents } from "./table-of-contents";

const TocComponentDisplay = () => {
    
    const { component } = useContext(ContentZoneContext);
    const { richtext } = component || {};

    return (
        <>
            <TableOfContents richtext={richtext} />
        </>
    );
};

TocComponentDisplay.displayName = "TocComponentDisplay";
export { TocComponentDisplay };
